const PreBlock = ({ children, className, ...rest }) => (
    <pre className="code-snippet" {...rest}>
        {children}
    </pre>
);

export default PreBlock;
